module.exports = __webpack_public_path__ + "img/sticker_2.41f3ee6e.svg";